export default __webpack_public_path__ + "static/media/food.25bd4a27.svg";